<template>
  <div class="launch">
    <div class="launchBlock">
      <p>Select Token to Launch</p>
      <n-select v-model:value="selectedToken" :options="selectTokens" label-field="name" value-field="key" :virtual-scroll="false" @update:value="loadImage"></n-select>
      <select v-model="selectedToken" @change="loadImage">
        <option v-for="t of selectTokens" :key="t" @select="loadImage" :value="t">{{ t.name }}</option>
      </select>
      <div class="tokenInfo" v-if="selectedToken">
        <img width="150" height="150" :src="selectedImageUrl" />
        <div class="tokenText">
          <p>Name: {{ selectedToken.name }}</p>
          <p>Symbol: {{ selectedToken.key.symbol }}</p>
          <p>Description: {{ selectedToken.key.description ? selectedToken.key.description : "-" }}</p>
          <p>Website: {{ selectedToken.key.website ? selectedToken.key.website : "-" }}</p>
          <p>Telegram: {{ selectedToken.key.telegram ? selectedToken.key.telegram : "-" }}</p>
          <p>Twitter: {{ selectedToken.key.twitter ? selectedToken.key.twitter : "-" }}</p>
          <p>Address: {{ selectedToken.key.mintPublicKey }}</p>
          <p>
            IPFS: <a :href="selectedToken.key.metadataUrl">{{ selectedToken.key.metadataUrl }}</a>
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="launchBlock">
            <p>Select Funding Wallet PAYER WALLET</p>
            <n-select></n-select>
        </div> -->
    <div class="launchBlock">
      <p>Write Jito Tips (default 0.00005 SOL)</p>
      <div class="input">
        <input v-model="jitoTips" :min="0.00005" />
      </div>
    </div>
    <button class="button" type="success" @click="launchToken">Launch</button>
  </div>
</template>

<script>
  import axios from "axios"
  import { useToast } from "vue-toastification"

  export default {
    name: "LaunchComponent",
    data() {
      return {
        selectTokens: this.$store.getters.getTokens,
        selectedToken: null,
        selectedImageUrl: "",
        jitoTips: 0.00005,
      }
    },
    methods: {
      async loadImage() {
        console.log(this.selectedToken)
        try {
          const response = await axios.get(this.selectedToken.key.imageUrl)
          this.selectedImageUrl = response.data.image
        } catch (error) {
          console.error("Ошибка загрузки данных:", error)
        }
      },
      launchToken() {
        if (this.selectedToken) {
          axios
            .post(
              `${process.env.VUE_APP_SERVERHOST}/api/token/deploy`,
              {
                tokenId: this.selectedToken.id,
                jitoTip: this.jitoTips,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
                },
              }
            )
            .then((res) => {
              console.log(res)
              this.toast.success(res.data.message, { timeout: 2000 })
            })
            .catch((err) => {
              console.log(err)
              this.toast.error(err.response.data.message, { timeout: 2000 })
            })
        } else this.toast.error("Please select token", { timeout: 2000 })
      },
    },
    mounted() {
      this.selectTokens = this.selectTokens.map((token) => ({
        name: token.name,
        id: token.key.id,
        key: token.key,
      }))
      // this.selectedToken = this.selectTokens[0]
      this.loadImage()
      console.log(this.selectedToken)
    },
    setup() {
      const toast = useToast()
      return { toast }
    },
  }
</script>

<style scoped>
  .launch {
    width: 40% !important;
    margin: 0 auto;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 1%;
    background-color: transparent;
    border-radius: 14px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .launchBlock {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #60cb89;
    border-radius: 5px;
    background: transparent;
    padding: 3%;
  }
  .tokenInfo {
    display: flex;
    gap: 20px;
  }
  :root {
    --n-color: #191919 !important;
  }
  :deep(.n-base-select-menu) {
    background-color: #191919 !important;
    color: white !important;
  }
  :deep(.n-base-selection) {
    background-color: #191919 !important;
  }
  :deep(.n-base-selection-label) {
    background-color: #191919 !important;
  }
  :deep(.n-base-select-menu__empty) {
    background-color: #191919 !important;
  }
  :deep(.n-select-menu .n-base-select-option) {
    background-color: transparent !important; /* Убираем фон */
  }
  :deep(.n-select-menu .n-base-select-option:hover) {
    background-color: rgba(0, 0, 0, 0.1) !important; /* Делаем мягкий hover */
  }
  :deep(.n-select-menu .n-base-select-option--selected) {
    background-color: rgba(0, 0, 0, 0.2) !important; /* Только выбранный элемент */
  }
  input {
    background-color: transparent;
    outline: none;
    border: none;
    color: white;
    height: 100%;
  }
  .button {
    background-color: #60cb89;
    color: white;
    border-radius: 5px;
    padding: 7px 30px;
    width: fit-content;
    font-size: 16px;
    border: none;
    cursor: pointer;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
